import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-customer-group-key'
const api = async (method, path, params) => axios[method](path, params)
function isValidPayload(payload) {
    if (!payload || !payload.name) {
        return false
    }
    return true
}
const state = {
    customer_group: {},
    customer_groups: [],
}

const mutations = {
    set_customer_group(state, payload) {
        state.customer_group = payload
    },
    set_customer_groups(state, payload) {
        state.customer_groups = payload
    },
}

const actions = {
    async create(context, payload) {
        new StorageCache(storageKey).reset()
        try {
            if (!isValidPayload(payload)) throw new Error('Data Required')
            const results = await api('post', `customer-group`, payload)
            context.commit('set_customer_group', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            const results = await api('get', `customer-group/${id}`)
            context.commit('set_customer_group', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await api('get', `customer-group`)
                console.log('results.data', results.data)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_customer_groups', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateCustomerGroupOrder(context, payload) {
        new StorageCache(storageKey).reset()
        try {
            await api('post', `customer-group/update/display/order/`, payload)
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        new StorageCache(storageKey).reset()
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `customer-group/${payload.id}`,
                payload
            )
            context.commit('set_customer_group', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        new StorageCache(storageKey).reset()
        try {
            await api('delete', `customer-group/${id}`)
            context.commit('set_customer_groups', null)
            // context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
